import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function FeaturedArticles() {
  const featuredArticles = articles.filter((a) => a.featured).slice(0, 6);

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-3 mb-12">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              精选文章
            </h2>
            <p className="text-sm text-foreground-500">
              编辑精心挑选的优质内容，让你快速了解吉泽明步
            </p>
          </div>
          <Link
            to="/category/news"
            className="flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featuredArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-background-300/60 transition-all duration-300"
            >
              <div className="relative w-full h-48 md:h-52 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  title={article.title}
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-3 mb-2.5">
                  <span className="px-2 py-0.5 rounded-md bg-primary-100 text-primary-700 text-xs font-medium">
                    {article.categoryName}
                  </span>
                  <span className="text-xs text-foreground-400 flex items-center gap-1">
                    <i className="ri-time-line"></i> {article.readTime}
                  </span>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 text-sm md:text-base mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-400">{article.date}</span>
                  <span className="text-xs font-medium text-primary-600 flex items-center gap-1 group-hover:gap-2 transition-all">
                    阅读全文 <i className="ri-arrow-right-s-line text-sm"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}